import type { SecretaryMessageInlineEditField } from '../components/SecretaryMessageInlineEdit'
import type { ChatMessage, MailDocumentPayload } from '../types/chat'

export type MailDocumentInlineEditField = 'subject' | 'message' | 'recipient_name'

export function mailDocumentInlineEditRowField(
  field: MailDocumentInlineEditField,
): SecretaryMessageInlineEditField {
  return field === 'subject' ? 'purpose' : field
}

export function mailDocumentDraftForField(
  mail: MailDocumentPayload,
  field: MailDocumentInlineEditField,
): string {
  if (field === 'subject') return (mail.mailSubject || mail.documentType || '').trim()
  if (field === 'message') return (mail.mailBody || '').trim()
  return (mail.recipientName || '').trim()
}

export function buildMailInlineEditCommand(
  field: MailDocumentInlineEditField,
  value: string,
  fr: boolean,
): string | null {
  const trimmed = value.trim()
  if (!trimmed) return null
  if (field === 'subject') return fr ? `modifier objet pour ${trimmed}` : `edit subject to ${trimmed}`
  if (field === 'message') return fr ? `modifier message pour ${trimmed}` : `edit message to ${trimmed}`
  return fr ? `modifier nom destinataire pour ${trimmed}` : `edit recipient name to ${trimmed}`
}

export function applyMailDocumentFieldUpdate(
  mail: MailDocumentPayload,
  field: MailDocumentInlineEditField,
  value: string,
): MailDocumentPayload {
  const v = value.trim()
  if (field === 'subject') return { ...mail, mailSubject: v }
  if (field === 'message') return { ...mail, mailBody: v }
  return { ...mail, recipientName: v }
}

/** Generic send-document mail (backend ``WF_MAIL_DOCUMENT``); not renew/sports NOC flows. */
export function isGenericMailDocumentPreviewMessage(m: ChatMessage): boolean {
  if (!m.mailDocument?.awaitingMailConfirmation && !m.awaitingMailConfirmation) return false
  if (m.sportsNocYesNoPrompt?.kind === 'mail_certificate') return false
  if (m.renewOrdonnanceYesNoPrompt?.kind === 'mail_renewed_ordonnance') return false
  if (m.renewOrdonnanceMailPrompt) return false
  return true
}

export function isMailDocumentPreviewEditable(m: ChatMessage, hist: boolean): boolean {
  if (hist) return false
  return Boolean(m.mailDocument?.awaitingMailConfirmation || m.awaitingMailConfirmation)
}
